export type serviceOptionType<T extends optionType = optionType> = {
  service_id: string
  option_id: number
  option_type: T
  name: string
  description: string
  enabled: boolean
  settings: T extends 'additional_purchase_option'
    ? additionalPurchaseOption
    : T extends 'bulk_discount'
      ? bulkDiscountSettings
      : serviceOptionSettingsType
  created_at: string
  updated_at: string
}

export type serviceOptionSettingsType = {
  [key: string]: string | number | boolean | null
}

export type optionType = 'additional_purchase_option' | 'bulk_discount'
export type serviceOptionSettings =
  | { type: 'additional_purchase_option'; settings: additionalPurchaseOption }
  | { type: 'bulk_discount'; settings: bulkDiscountSettings }

export type additionalPurchaseOptionElement = {
  item_id: number
  category_id: number
  name: string
  price: number
  image_url: string
  description: string
}

export type additionalPurchaseOption = {
  choices: additionalPurchaseOptionElement[]
}

export type bulkDiscountSettings = {
  min_quantity: number
  discount_rate: number
  discount_type: 'percentage' | 'fixed_amount'
  applicable_to: 'same_item' | 'any_item'
  max_discount_amount?: number
}

export function isAdditionalPurchaseOption(
  option: serviceOptionType,
): option is serviceOptionType<'additional_purchase_option'> {
  return option.option_type === 'additional_purchase_option'
}

export function isBulkDiscountOption(
  option: serviceOptionType,
): option is serviceOptionType<'bulk_discount'> {
  return option.option_type === 'bulk_discount'
}
